import { ACCESS_TOKEN_NAME, JSON_CONTENT_TYPE } from '../constant/constants';
import { IApiParams } from '../interface/IApiParams';
import { getApi } from './getApi';

export const apiGetLectionImage = async (section: string, lection: string) => {
  const params: IApiParams = {
    url: `/api/lectionImages.php?section=${section}&lection=${lection}`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': localStorage.getItem(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'GET');
};
